module.exports = __webpack_public_path__ + "static/media/coming_soon.6ac056fc.jpg";